import Vue from "vue";
import Vuex from "vuex";

import staticState from "./modules/staticState";
import authoState from "./modules/authoState";
import globalState from "./modules/globalState";
import tempState from "./modules/tempState";
import langState from "./modules/langState";
import platformAccountData from "./modules/platformAccountData";
import team from './modules/team';

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

// 保持既有本地缓存键，避免品牌升级后丢失登录和团队状态。
const createPersisted = createPersistedState({
  key: "JOINMC_STORE",
  storage: window.localStorage,
  paths: ["authoState", "globalState", "tempState", "team"],
});

const store = new Vuex.Store({
  modules: {
    staticState,
    authoState,
    globalState,
    tempState,
    langState,
    platformAccountData,
    team,
  },
  plugins: [
    createPersisted,
    (store) => {
      store.subscribe((mutation, state) => {
        if (mutation.type === "authoState/setToken" || mutation.type === "authoState/CLEAR_AUTH_STATE") {
          const { token, tokenTimestamp } = state.authoState;
          localStorage.setItem("token", token || "");
          localStorage.setItem("tokenTimestamp", tokenTimestamp || "");
        }
      });
    },
  ],
  state: {
    APP_NAME: "",
    /**
     * whatsapp 模板对象
     * @type {TmplSelectComponents}
     */
    whatAppTemplateComponents: {},
  },
  mutations: {
    SET_APP_NAME(state, data) {
      state.APP_NAME = data;
    },
    /**
     * whatsapp 模板预览对象
     */
    stashWhatsAppTemplateComponents(state, data) {
      state.whatAppTemplateComponents = data;
    },
  },
  actions: {},
  getters: {
    /**
     * whatsapp 模板对象
     * @returns {TmplSelectComponents}
     */
    whatAppTemplateComponents: (state) => state.whatAppTemplateComponents,
    GET_APP_NAME: (state) => state.APP_NAME,
  },

});

export default store;
